import React from 'react';
import classes from './AddButton.scss';

export default (props) => {
  return <div className={classes['add-button']} {...props}></div>;
};
